import { HeaderMinimal } from "../components/Header";
import { BrutalButton, BrutalInput } from "../components/BrutalUI";
import type { UsernameConfig } from "../types";

export default function UsernameView({ slug }: UsernameConfig) {
  return (
    <>
      <HeaderMinimal />
      <main className="flex-1 flex flex-col items-center justify-center p-6 max-w-2xl mx-auto text-center">
        <p className="text-lg text-gray-700 dark:text-gray-300 mb-6">
          Enter your name to join this calendar.
        </p>
        <form method="post" action={`/c/${slug}`} className="m-0 flex flex-col items-center gap-4">
          <BrutalInput
            type="text"
            name="username"
            placeholder="Your name"
            required
            autoFocus
            className="w-full max-w-xs"
          />
          <BrutalButton type="submit" variant="primary" className="px-6 py-3 text-base min-h-[2.75rem]">
            Continue
          </BrutalButton>
        </form>
      </main>
    </>
  );
}
